import jwt_decode from "jwt-decode";

export interface AuthState {
	isAuthenticated: boolean;
	tokens?: any;
	userInfo?: {
		azp: string;
		exp: number;
		prefered_username: string;
		family_name: string;
		given_name: string;
		name: string;
		resource_access: {
			[id: string]: {
				roles: string[];
			};
		};
	};
}

/**
 * Extracts the infomration of an auth Token and creates an AuthState
 * @param tokens Keycloak tokens
 */
export const getAuthStateFromToken = (
	tokens: any = {
		idToken: "",
		refreshToken: "",
		token: "",
	}
): AuthState => {
	const decodedJwt =
		tokens && tokens.idToken ? (jwt_decode(tokens.idToken) as any) : {};
	return {
		isAuthenticated: !!(tokens && tokens.token),
		tokens,
		userInfo: {
			resource_access: {},
			azp: "",
			exp: 0,
			prefered_username: "",
			family_name: "",
			given_name: "",
			name: "",
			...decodedJwt,
		},
	};
};
